module.exports = __webpack_public_path__ + "static/media/smile_english.2500021e.png";